<template>
  <div>
    <div v-if="show" @click="show = false"
    class="detail_main z-index31"
    :class="{'popBg': show}">
    </div>
    <section v-if="show" class="bottomRouge contact z-index32">
      <div  class="has-background-primary has-text-white commercialContentTop
              topViolet p_size14 is-marginless">
          <p>Une question ?</p>
          <div v-if="telCommercial">
            <p> Contactez-moi au
              <a
                :href="`tel:${telCommercial}`"
                class="has-text-weight-bold has-text-white underline"
              >
                {{telCommercial}}</a>
            </p>
            <p>ou par email
            <p>
              <a :href="`mailto:${dataInfoCommercial.contact.email}`"
              class="has-text-weight-bold has-text-white underline">
              {{dataInfoCommercial.contact.email}}
              </a>
            </p>
          </div>
          <div v-else>
            <p>Contactez moi par mail
              <a :href="`mailto:${dataInfoCommercial.contact.email}`"
                 class="has-text-weight-bold has-text-white underline">
                {{dataInfoCommercial.contact.email}}
              </a>
            </p>
          </div>
        </div>
        <div class="commercialContentBottom has-background-white">
            <p class="has-text-link has-text-weight-bold p_size14">
              {{dataInfoCommercial.contact.nom}}
              {{dataInfoCommercial.contact.prenom}}
            </p>
            <p class="p_size12 has-text-default">
              Commercial(e) chez
              <strong class="has-text-default">
                {{dataInfoCommercial.nomCommercial}}
              </strong>
            </p>
        </div>
    </section>
    <div class="contact z-index32">
      <div v-if="pShow">
        <a @click="show = !show"
          class="is-marginless is-paddingless pastille
          level-right is-danger button is-rounded">
          <p class="p_size12 mr5">1</p>
        </a>
      </div>
      <a :href="`tel:${telCommercial}`" v-if="show"
       class="button is-primary is-rounded p_size14 has-text-weight-bold">
        <b-icon v-if="show"
          icon="phone"
          size=""
        ></b-icon>
      </a>
      <a :href="`mailto:${dataInfoCommercial.contact.email}`" v-if="show"
          class="button is-primary is-rounded p_size14 has-text-weight-bold">
        <b-icon v-if="show"
          icon="email"
          size=""
        ></b-icon>
      </a>
      <a @click="show = !show ; pShow = false"
          class="level-right button is-primary is-rounded p_size14 has-text-weight-bold">
          Contact
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'infoCommercial',
  props: ['dataInfoCommercial', 'client'],
  data() {
    return {
      show: false,
      pShow: true,
    };
  },
  computed: {
    telCommercial() {
      return this.dataInfoCommercial.contact.telephone;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/composants/infoCommercial.vue